export default __webpack_public_path__ + "static/media/shield.cd73ecdb.png";